import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import {
  Divider,
  FluentProvider,
  makeStyles,
  Text,
  webLightTheme,
  Link,
} from '@fluentui/react-components';
import React from 'react';
import { OpenRegular } from '@fluentui/react-icons';

const helpSectionHeaderStyles = {
  root: { fontWeight: '600', paddingBottom: 10 },
};
interface IHelpSectionLink {
  href: string;
  name: string;
}
const resourcesConfig = [
  {
    href: 'https://microsoft.sharepoint.com/:p:/t/Stat/EVTP_k3jvhRKsDYAw3Zn80gBl_yEqEm8vITBPjwwCqzmeg?e=5t2SHB',
    name: 'STAT Introduction',
  },
  {
    href: 'https://aka.ms/stat/faq',
    name: 'FAQs',
  },
  {
    href: 'https://aka.ms/stat/videos',
    name: 'Training Videos',
  },

  {
    href: 'https://aka.ms/stat/resources',
    name: 'STAT Resources Sharepoint',
  },
  {
    href: 'https://aka.ms/stat/policy',
    name: 'Statutory Compliance Policy',
  },
  {
    href: 'http://go.microsoft.com/fwlink/?LinkId=518021',
    name: 'Microsoft Data Privacy Notice',
  },
] as IHelpSectionLink[];

const dividerStyles = makeStyles({
  divider: {
    // same as v8: top/bottom padding, no left/right
    padding: '20px 0',
  },
});

const getExternalLink = (link: IHelpSectionLink) => {
  return (
    <FluentProvider theme={webLightTheme} key={link.name}>
      <Link target="_blank" rel="noopener noreferrer" href={link.href}>
        {link.name} <OpenRegular />
      </Link>
    </FluentProvider>
  );
};
const HelpPanel = (): JSX.Element => {
  const styles = dividerStyles();

  return (
    <Stack>
      <Text size={400} style={helpSectionHeaderStyles.root}>
        Resources
      </Text>
      <p>Use these videos and documents to learn about STAT:</p>

      <Stack tokens={{ childrenGap: 5 }}>
        {resourcesConfig.map((link) => {
          return getExternalLink(link);
        })}
      </Stack>
      <FluentProvider theme={webLightTheme}>
        <Divider className={styles.divider} />
      </FluentProvider>
      <Text size={400} style={helpSectionHeaderStyles.root}>
        Help/Support
      </Text>
      <Stack tokens={{ childrenGap: 20 }}>
        <Stack>
          {getExternalLink({ name: 'Contact FinSup', href: 'https://aka.ms/FinSup' })}

          <p>
            General inquiries, access, error messages, process configuration, standard reporting,
            navigation, document upload.
          </p>
        </Stack>
        <Stack>
          {getExternalLink({
            name: 'Contact STATInfo',
            href: 'mailto:statinfo@microsoft.com?subject=STAT%20Question',
          })}
          <p>
            Business process questions, policy requirements (WHICH document is needed), policy
            exceptions, financial statement reviews, dividend coordination, new company creation,
            late audit status update.
          </p>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default HelpPanel;
